<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} APR Rate</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div class="upload">
					<div class="form-group custom-body-content">
						<label class="label required">Domicile
							<span style="color:#ff0000">*</span></label>
						<div>
							<input type="text" id="domicile" name="domicile" required class="domicile"
								[(ngModel)]="domicile" maxlength="5">
						</div>
					</div>
				</div>

				<div class="upload">
					<div class="form-group custom-body-content">
						<label class="label">Over The Road
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="number" min="0" max="99" id="otr" name="otr" required class="otr"
								[(ngModel)]="otr">
						</span>
					</div>
				</div>

				<div class="upload">
					<div class="form-group custom-body-content">
						<label class="label">Handling Charge
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="number" min="0" max="99" id="handling" name="handling" required
								class="handling" [(ngModel)]="handling">
						</span>
					</div>
				</div>

				<label *ngIf="enableError" class="errormsg"> Please fill in the required fields! </label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="costpl-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>